(() => {
 const selectors = {
  body: 'body',
  overflowVideo: '.overflow-video-wrapper',
  videoModalOpenButton: '.js-video-modal-button',
  videoModalCloseButton: '.js-close-video-modal',
  videoModalWrapper: '.steps__video-modal-wrapper',

  bodyOverflowClass: 'body--overflow',
  overflowVideoActiveClass: 'overflow-video-wrapper--active',
  videoModalWrapperActiveClass: 'steps__video-modal-wrapper--active',
 };

 const videoModalButton = document.querySelectorAll(selectors.videoModalOpenButton);
 const videoCloseButton = document.querySelectorAll(selectors.videoModalCloseButton);

  function closeVideoModal() {
    const body = document.querySelector(selectors.body);
    const overflowVideo = document.querySelector(selectors.overflowVideo);
    const videoModalWrapper = document.querySelector(selectors.videoModalWrapper);

    if (videoModalWrapper) {
      videoModalWrapper.classList.remove(selectors.videoModalWrapperActiveClass);
      body.classList.remove(selectors.bodyOverflowClass);
      overflowVideo.classList.remove(selectors.overflowVideoActiveClass);
      const iframe = videoModalWrapper.querySelector('iframe');
      const videoUrl = iframe.getAttribute('src');

      iframe.setAttribute('src', '');
      iframe.setAttribute('src', videoUrl);
    };
  };

  function openVideoModal() {
    const body = document.querySelector(selectors.body);
    const overflowVideo = document.querySelector(selectors.overflowVideo);
    const videoModalWrapper = document.querySelector(selectors.videoModalWrapper);

    if (videoModalWrapper) {
      videoModalWrapper.classList.add(selectors.videoModalWrapperActiveClass);
      body.classList.add(selectors.bodyOverflowClass);
      overflowVideo.classList.add(selectors.overflowVideoActiveClass);
    };
  };

  videoModalButton.forEach((button) => {
    button.addEventListener('click', openVideoModal);
  });

  videoCloseButton.forEach((element) => {
    element.addEventListener('click', closeVideoModal);
  });
})();
